import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../../themes/palette";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "75vh",
    marginTop: theme.spacing(0),
  },
  mainAboutusContainer: {
    paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
    paddingRight: theme.spacing(myTheme.padding.right + 3.4),
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2.3),
      paddingRight: theme.spacing(2.3),
      //marginLeft:'15%'
    },
  },
  avatar: {
    width: 50,
    height: 50,
    margin: theme.spacing(0),
    backgroundColor: theme.palette.primary.main,
  },
  paper: {
    margin: theme.spacing(0, 8),
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down(700)]: {
      margin: theme.spacing(1.8, 4),
    },
  },
  avatarInProfileSetting: {
    height: "120px",
    width: "120px",
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.down(700)]: {
      height: "60px",
      width: "60px",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0),
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
  },
}));

export default useStyles;
